import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

// Dynamic API URL functions that get the current API base URL at runtime
const getUserApi = () => `${getCurrentApiBaseUrl()}/user/practice`;
const getUpdatePractice = () => `${getCurrentApiBaseUrl()}/user/practice-custom`;

const practiceService = {
  getPracticeList: (payload) => {
    if (payload && payload.name) {
      return service.get(`${getUserApi()}?name=${payload.name}`, {});
    }
    return service.get(`${getUserApi()}`, {});
  },
  deletePractice: (payload) => {
    return service.deleteJson(`${getUserApi()}?practiceId=${payload.practiceId}`);
  },
  updatePractice: (payload) => {
    return service.putJson(`${getUpdatePractice()}`, payload);
  },
};

export default practiceService;
